


















































































































































import Organization from "@/classes/Organization";
import SubscriptionLibrary from "@/classes/SubscriptionLibrary";
import LibrarySubscriptionValidationRule from "@/classes/rules/LibrarySubscriptionValidationRule";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class PurchasedLibraries extends Vue {
  @Prop(Object) public organization: Organization;
  public valid: boolean = false;
  public selectedLibrary: object = {};
  public perPageOptions: Array = [5, 25, 50, 100];

  public validationRule: LibrarySubscriptionValidationRule = new LibrarySubscriptionValidationRule();

  public get getOrganization() {
    return this.organization;
  }

  public get pagination() {
    return this.$store.getters["libraries/getPagination"];
  }
  public set pagination(val) {
    this.$store.commit("libraries/setPagination", val);
  }

  public get getPaginationLength() {
    return Math.ceil(this.totalCount / this.pagination.itemsPerPage);
  }

  private get librariesToUpdate() {
    return this.$store.getters["libraries/getSubscriptionLibrariesToUpdate"];
  }
  private set librariesToUpdate(val) {
    this.$store.commit("libraries/setSubscriptionLibrariesToUpdate", val);
  }

  public get query() {
    return this.$store.getters["libraries/getQuery"];
  }
  public set query(val) {
    this.$store.commit("libraries/setQuery", val);
  }

  public get totalCount() {
    return this.$store.getters["libraries/getTotalSubscriptionLibraryCount"];
  }

  public get libraries() {
    return this.$store.getters["libraries/getSubscriptionLibraries"];
  }

  public changePage() {
    this.$store.dispatch(
      "libraries/searchSubscriptionLibrariesAsync",
      this.organization.id
    );
  }

  public search() {
    this.pagination.page = 1;
    this.$store.dispatch(
      "libraries/searchSubscriptionLibrariesAsync",
      this.organization.id
    );
  }

  public updateLibraries() {
    this.$store.dispatch(
      "libraries/updateLibrarySubscriptionsAsync",
      this.organization.id
    );
  }

  public mounted() {
    this.$store.dispatch(
      "libraries/searchSubscriptionLibrariesAsync",
      this.organization.id
    );
  }

  public pushLibraryIfNotFound(library) {
    const idx = this.librariesToUpdate.findIndex(
      (o: SubscriptionLibrary) => o.id === library.id
    );
    if (idx !== -1) {
      this.librariesToUpdate.splice(idx, 1);
    }
    this.librariesToUpdate.push(library);
  }
}
